import React, { Component } from 'react';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';

import WavyLayout from './../../../hoc/WavyLayout/WavyLayout';

import HistoryEntry from './../HistoryEntry/HistoryEntry';

//-- Utils
import { pushHeaderTitle } from '../../../utils/dom/helper';
import { pushPageView } from '../../../utils/tracking/customGtm';

export class HistoryList extends Component {
    
    componentDidMount() {
        //-- Update title
        pushHeaderTitle('Historique des points');

        //-- Push GTM page view
        pushPageView();
    }
    
    handleClick = () => {
        const { dispatch } = this.props;
        dispatch(goBack());
    }
    
    render(){

        const { history } = this.props;
        return (

            <WavyLayout 
                page="history"
                title="Historique"
                color="gradient"
                handleClick={this.handleClick}>
                <div className="kiddy"></div>
                <div className="calendar"></div>
                <ul className="history-list">
                    <li className="hidden-line"></li>
                    { history.map((entry, index) =>   <li key={`history-list-${index}`}><HistoryEntry entry={entry} /></li>)}
                </ul>
            </WavyLayout>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        history: state.history.history
    };
}

export default connect( mapStateToProps )(HistoryList);



// WEBPACK FOOTER //
// ./src/components/History/HistoryList/HistoryList.js